var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "17px",
    viewBox: "0 0 22 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "designer/editor-rect-canvas-copy",
    transform: "translate(-97.000000, -946.000000)",
    fillRule: "nonzero",
    fill: "#7ED321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cutting",
    transform: "translate(20.000000, 871.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rechteckig",
    transform: "translate(2.000000, 32.636842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkmark",
    transform: "translate(75.000000, 42.363158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89378261,16.1898286 C8.90282609,17.1962286 7.29491304,17.1962286 6.30443478,16.1898286 L0.743217391,10.5419429 C-0.24773913,9.53602857 -0.24773913,7.90305714 0.743217391,6.89714286 C1.73369565,5.89074286 3.3416087,5.89074286 4.33256522,6.89714286 L7.64595652,10.2616857 C7.89608696,10.5152286 8.30213043,10.5152286 8.55273913,10.2616857 L17.5244348,1.15017143 C18.514913,0.143771429 20.1228261,0.143771429 21.1137826,1.15017143 C21.5896522,1.63345714 21.857,2.28917143 21.857,2.97257143 C21.857,3.65597143 21.5896522,4.31168571 21.1137826,4.79497143 L9.89378261,16.1898286 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.556a07f6ef2388ef087d83a69401131a.svg";
export { ForwardRef as ReactComponent };